/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomSelect, CustomModal, Loader, CustomTitle } from 'src/components'
import { Empty, Select, Form, Button, Divider } from 'antd'
import {
  getAllUserIntegrationsToShareForAccount,
  integrationProjectToShareSelector,
  addProjectToIntegrations,
  cleanProjectId,
} from 'src/features'

interface IntegrationToShareProjectModalProps {
  isModalVisible: boolean
  // eslint-disable-next-line no-unused-vars
  setIsModalVisible: (value: boolean) => void
  project_id: number
  projectName: string
}

const IntegrationToShareProjectModal: React.FC<IntegrationToShareProjectModalProps> = (props) => {
  const { isModalVisible, setIsModalVisible, project_id, projectName } = props
  const route = useRouter()
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const { id: integration_id } = route.query
  const { loading, data, projectId } = useAppSelector(integrationProjectToShareSelector)

  useEffect(() => {
    dispatch(getAllUserIntegrationsToShareForAccount(Number(integration_id), project_id))
    return () => { dispatch(cleanProjectId()) }
  }, [dispatch, project_id, integration_id])


  const onFinish = (values: { integration_code: string }) => {
    dispatch(addProjectToIntegrations(Number(projectId), values.integration_code, integration_id))
    form.resetFields()
  }

  return <>
    <CustomModal
      title={ t(`developers.ShareProjectTitle`, { projectName })}
      footer={ null }
      open={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
    >
      {loading ? <Loader /> : data?.length === 0 ? (
        <Empty description={t('developers.NoIntegrations')} />
      ): data?.length > 0 && <>
        <Form onFinish={onFinish} form={form}>
          <CustomTitle label={t('developers.Business')} />
          <CustomSelect
            required
            name='integration_code'
            placeholder={t('developers.SelectBusinessPlaceholder')}
          >
            {data.map((item, idx) => <Select.Option
              value={item.integration_code} key={idx}>
              {item.integration_code}
            </Select.Option>)}
          </CustomSelect>
          <Divider />
          <Button
            block
            size='large'
            type='primary'
            htmlType='submit'
            className='radius-100'
          >{t('developers.ShareProjectSelected')}
          </Button>
        </Form>
      </>}
    </CustomModal>
  </>
}
export default IntegrationToShareProjectModal
